// extracted by mini-css-extract-plugin
export const flexStyles = "headerStyle-module--flexStyles--1ihi0";
export const siteHeader = "headerStyle-module--siteHeader--1L_Cn";
export const socialMedia = "headerStyle-module--socialMedia--JNjeG";
export const navigationMenu = "headerStyle-module--navigationMenu--3hOn3";
export const openSubmenu = "headerStyle-module--openSubmenu--1HYCa";
export const submenu = "headerStyle-module--submenu--cNlZ3";
export const overlay = "headerStyle-module--overlay--1zY0u";